/**
 * Penentuan menu sidebar yang sedang aktif.
 *
 * React Router menandai NavLink aktif untuk SEMUA rute yang berawalan sama,
 * sehingga "/kegiatan" ikut menyala saat pengguna membuka "/kegiatan/baru".
 * Fungsi di sini memilih SATU tujuan paling spesifik saja, supaya hanya menu
 * yang benar-benar diklik yang tersorot.
 */

/** Normalisasi path: buang garis miring di ujung, akar tetap "/". */
export function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

/** Apakah `pathname` berada di dalam cabang `to` (termasuk tepat sama). */
export function isWithinSection(to: string, pathname: string): boolean {
  const path = normalizePath(pathname);
  if (to === "/") return path === "/";
  return path === to || path.startsWith(`${to}/`);
}

/**
 * Pilih satu tujuan navigasi yang aktif; kandidat terpanjang menang sehingga
 * "/kegiatan/baru" mengalahkan "/kegiatan" dan hanya satu menu yang menyala.
 */
export function activeNavTarget(pathname: string, targets: readonly string[]): string | null {
  let active: string | null = null;
  for (const target of targets) {
    if (!isWithinSection(target, pathname)) continue;
    if (active === null || target.length > active.length) active = target;
  }
  return active;
}

/** Apakah item menu dengan tujuan `to` sedang aktif. */
export function isNavItemActive(pathname: string, to: string, targets: readonly string[]): boolean {
  return activeNavTarget(pathname, targets) === to;
}
